import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'ct-dropdown-component',
  templateUrl: './ct-dropdown-component.component.html',
  styles: [
  ]
})
export class CtDropdownComponentComponent implements OnInit, OnChanges {
  @Input() items: any[] = [];
  @Input() disabled: boolean = false;
  @Input() showProperty: string = "";
  /**
   * prilikom popunjavanja dropdowna iz localstorage-a
   * potrebno je selektovati odgovarajucu opciju iz menija
   * idProperty sluzi za identifikator za pronalazenje 
   * odgovarajuce opcije
   */
  @Input() idProperty: string = "id";
  @Input() pageNumber: number = 1;
  @Input() pageSize: number = 10;
  @Input() numberOfItems: number = 0;
  @Input() label: string = "";
  @Input() setSelectedItems: any;
  @Input() showBoldLabel: boolean = false;
  @Input() labelForRequred: string;
  @Input() showLabel: boolean = true;
  @Input() required: boolean = false;

  /**
   * matTooltip se azurira preko Observable tooltipTextObservable
   * jer ukoliko imamo da je samo Input() onda ne radi lepo
   */
  @Input() tooltipTextObservable: Observable<string> = new Observable<string>();
  private eventSubscription: Subscription = new Subscription();
  /**
   * Indikator koji oznacava dali ce selekt
   * polje da bude multiselect ili ne
   * inicijalno je postavljeno da ne bude
   */
  @Input() selectMultiple: boolean = false;
  /**
   *   Nacin vracana rezultata.
   *   CallBackFunction = 0, preko callback funkcije
   *   Subject = 1, preko subjecta
  */
  @Input() outputType: OutputType = 0;
  /**
   * Input odredjuje da li ce da se korisitio dodatno ucitavanje(true)
   *  ili ce se koristiti paginacija(false).
  */
  // @Input() useAdditionalLoad: boolean = true;
  /**
   * Rezultat u subject formatu.
  */
  @Input() result: Subject<any> | undefined;
  /**
   * Funkcija koja se poziva nakon odabira sloga.
  */
  @Output() selectedValue = new EventEmitter<any>();
  /**
   * Funkcija koja se poziva nakon promene paginacije 
   * koja treba da izmeni podatke koji se prikazuju.
  */
  @Output() setValues = new EventEmitter<any>();
  /**
   * Funkcija koja se poziva nakon pretrage 
   * (nakon sto se pritisne dugme za pretragu ili pritisne enter)
   */
  @Output() searchValues = new EventEmitter<any>();

  form: FormGroup;
  maxPages: number = 0;
  tooltipText: string = "";
  /**
   * Tekst koji se ispisuje prilikom postavljanja 
   * kursora na komponentu (prikaz selektovanih vrednosti)
   */

  selectedItem: any;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      selectedItem: null,
      search: ""
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.numberOfItems && this.pageSize)
      this.maxPages = Math.ceil(this.numberOfItems / this.pageSize);
    if (changes.items) {
      if (Array.isArray(this.setSelectedItems) && this.setSelectedItems.length > 0) {
        this.tooltipText = "";
        let allSelectedItem = [];
        this.setSelectedItems.forEach(selectedItem => {
          let item = this.items.find(x => x[this.idProperty] == selectedItem);
          allSelectedItem.push(item);
          this.tooltipText += this.getValue(item) + ',';
        });
        this.form.get('selectedItem').setValue(allSelectedItem);
        this.tooltipText = this.replaceLastChar(this.tooltipText, "");
      }
      else if (!Array.isArray(this.setSelectedItems) && this.setSelectedItems != null) {
        this.tooltipText = "";
        this.selectedItem = this.items.find(x => x[this.idProperty] == this.setSelectedItems[this.idProperty]);
        this.form.get('selectedItem').setValue(this.selectedItem);
        this.tooltipText += this.getValue(this.selectedItem) + ',';
        this.tooltipText = this.replaceLastChar(this.tooltipText, "");
      }
    }
    if (this.required) {
      this.form.get('selectedItem').addValidators([Validators.required]);
      this.form.get('selectedItem').updateValueAndValidity();
    }
  }

  ngOnInit(): void {
    this.eventSubscription = this.tooltipTextObservable?.subscribe(res => {
      this.tooltipText = res;
    });

  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  getValue(item: any) {
    if (this.showProperty != "" && item != undefined)
      return item[this.showProperty];

    return item;
  }

  /**
   * prilikom selektovanja vrednosti
   * ova metoda prosledi vrednost roditeljskoj
   * komponenti i u zavisnosti da li je izabran
   * multiselect onda popuni i promenljivu tooltipText
   * (prikaz svih selektovanih vrednosti)
   * @param change 
   */
  onChange(change: MatSelectChange) {
    if (this.outputType == OutputType.Subject) {
      this.result?.next(change.value);
    }
    else if (this.selectMultiple) {
      this.tooltipText = "";
      change.value.forEach((element: any) => {
        this.tooltipText += this.getValue(element) + ',';
      });
      this.tooltipText = this.replaceLastChar(this.tooltipText, "");
    }
    else {
      this.tooltipText = this.getValue(change.value);
    }
    this.selectedValue.emit(change.value);
  }

  private replaceLastChar(inputString: string, newChar: string): string {
    if (inputString.length === 0) {
      return newChar;
    }
    const characters = inputString.split('');
    characters[characters.length - 1] = newChar;
    return characters.join('');
  }

  setItemsScroll() {
    this.setValues.emit({
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchValue: this.form.get('search')?.value
    })
  }

  setItemsPage() {
    this.setValues.emit({
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchValue: this.form.get('search')?.value
    })
  }

  loadNext() {
    if (!this.isDisabled()) {
      this.pageNumber++;
      this.setItemsScroll();
    }
  }

  nextPage() {
    this.pageNumber++;
    this.setItemsPage();
  }

  previousPage() {
    this.pageNumber--;
    this.setItemsPage();
  }

  isDisabled() {
    return this.pageNumber >= this.maxPages;
  }

  isPreviousDisabled() {
    return this.pageNumber == 0;
  }
  /**
   * Funkcija koja se poziva prilikom pretrage
   */
  search() {
    this.pageNumber = 1;
    this.searchValues.emit({
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchValue: this.form.get('search')?.value
    });
  }

  empty() {
    this.form.get('selectedItem').setValue([]);
    this.tooltipText = "";
    if (this.selectMultiple)
      this.selectedValue.emit([]);
    else
      this.selectedValue.emit(null);
  }

  getPageInfo() {
    return (this.pageNumber + 1) + "/" + this.maxPages;
  }

  dodajValidatore() {
    this.form.get('selectedItem').addValidators([Validators.required]);
    this.form.get('selectedItem').updateValueAndValidity();
    //this.form.markAllAsTouched();
  }

  ukloniValidatore() {
    this.form.get('selectedItem').clearValidators();
    this.form.get('selectedItem').updateValueAndValidity();
  }

  izmeniPrikazLabele(event) {
    this.showLabel = !event;
  }

  zatvoriSelect(event: KeyboardEvent, select: MatSelect) {
    event.preventDefault();  // Spreči default (otvaranje/odčekiranje)
    select.close();          // Programatski zatvori dropdown
  }
}

enum OutputType {
  CallBackFunction,
  Subject
}
